import { Outlet } from "react-router-dom"
import { SaleHeader } from "../components/global/SaleHeader"
import { Navbar } from "../components/global/Navbar"
import { Footer } from "../components/global/Footer"
import { CustomButton } from "../components/global/CustomButton"
import "./clientLayout.css"

export function ClientLayout() {
    return (
        <>
            <SaleHeader />
            <div className="d-flex justify-content-center admin-btn">
                <CustomButton
                    color="primary"
                    text="Admin Dashboard"
                    btnLink={true}
                    path="/admin"
                />
            </div>
            <Navbar />
            <hr className="m-0" />
            <Outlet />
            <Footer />
        </>
    )
}